import React, {Fragment} from "react";
import {Listbox, Transition} from "@headlessui/react"

export const DropdownListFormNotSelectedId = -1
// "_blank"
export const DropdownListFormNotSelectedStringId = "-----"

export interface DropdownListItem {
    name: number | string,
    id: any
}

interface IProps {
    title?: string,
    placeholder?: string,
    id: any,
    data: Array<DropdownListItem>,
    errMsg?: string,
    onChange: (id: any) => void
}

function DropdownListForm(props: IProps) {
    const {title, id, data, placeholder = "", onChange} = props

    const item = data.find((_item) => {
        // _item.id !== DropdownListFormNotSelectedStringId &&
        return _item.id !== DropdownListFormNotSelectedId && _item.id === id
    })
    const selectedName:string = (item?.name || "").toString()
    return (
        <div className={"w-full"}>
            <p className={"relative text-gray-1 text-sm text-left mb-1"}>{title}</p>
            <div className={"relative w-full"}>
                <Listbox value={id} onChange={(val) => {
                    onChange && onChange(val)
                }}>
                    {({open}) => {
                        return (
                            <div className="w-full">
                                <Listbox.Button className={`w-full py-2 px-4 flex flex-row justify-between items-center bg-gray-6 h-10 rounded-md border border-transparent focus:outline-none ${open ? "border-theme-blue outline-none ring-4 ring-color-theme" : ""}`}>
                                    <p className={`text-sm text-left ${selectedName.length ? "text-input" : "text-gray-500"}`}>{selectedName.length ? selectedName : placeholder}</p>
                                    <div className={`${data && data.length > 1 ? "" : "hidden"}`}>
                                        <svg width="13" height="6" viewBox="0 0 13 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10 2.25L6.51841 3.99079L3.03683 2.25" stroke="#BDBDBD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    </div>
                                </Listbox.Button>
                                {data.length > 1 ? (
                                    <Transition
                                        as={Fragment}
                                        enter="transition duration-100 ease-out"
                                        enterFrom="transform scale-95 opacity-0"
                                        enterTo="transform scale-100 opacity-100"
                                        leave="transition duration-75 ease-out"
                                        leaveFrom="transform scale-100 opacity-100"
                                        leaveTo="transform scale-95 opacity-0"
                                    >
                                        <Listbox.Options static className="z-30 bg-white absolute w-full py-1 mt-1.5 overflow-auto text-base bg-white rounded-lg shadow-2xl border max-h-60 focus:outline-none">
                                            {data.map((item, idx) => {
                                                const title = item.name
                                                return (
                                                    <Listbox.Option
                                                        key={idx}
                                                        value={item.id}
                                                        className={"px-1"}
                                                    >
                                                        {({active }) => {
                                                            return (
                                                                <div
                                                                    className={`${
                                                                        active ? "bg-theme-blue-10 text-theme-blue font-semibold" : "bg-white text-gray-1 font-normal"
                                                                    } cursor-pointer w-full py-2 px-4 text-sm rounded`}
                                                                >
                                                                    {/* {selected && <i className="fas fa-check mr-4"></i>}*/}
                                                                    {title}
                                                                </div>
                                                            )
                                                        }}
                                                    </Listbox.Option>
                                                )
                                            })}
                                        </Listbox.Options>
                                    </Transition>
                                ) : null}
                            </div>
                        )
                    }}
                </Listbox>
            </div>
        </div>
    )
}

export default DropdownListForm
